import { doQueries, type IQueryInfo } from 'infrastructure/api'

export function doIngestionQueries<T>(
  queries: IQueryInfo[],
  throwError: boolean,
) {
  return doQueries<T>('/api/curriculaingest', queries, throwError)
}
